import React, { createRef } from "react";
import { connect } from "react-redux";
import { Spinner } from "../../Components/Spinner/Spinner";

import * as SignalR from "@aspnet/signalr";

import { callAPI } from "../../assets/Js/backendCommunication";

import { getPlainToken } from "../../assets/Js/tokenHandler";

import projectSettings from "../../assets/Js/projectSettings";

import MessageSectionList from "./MessageSectionList.js";

import parseJwt from "../../assets/Js/jwtParse";
import "./message.css";

import DisplayPicture from "../../Components/DisplayPicture/DisplayPicture";
import GifsandStickers from "../../Components/GifsandStickers/GifsandStrickers";
import gifTypes from "../../assets/Js/gifTypes";
import uuid from "react-uuid";

import messageType from "../../assets/Js/messageTypesEnum";

import alternateImage from "../../assets/Images/alternateImage.jpg";
import GroupDetails from "../GroupDetials/GroupDetails";
import CreateCustomGroup from "../CreateCustomGroup/CreateCustomGroup";
import ModalBody from "../../Components/ModalBody/ModalBody";
import { openModel } from "../../assets/Js/openModel";
import { closeModel } from "../../assets/Js/closeModel";
import { chatGroupEnum } from "../../assets/Js/chatGroupEnum";

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
  };
};

const groupDetailsModalId = "groupDetailsModal";

const initialState = {
  messageList: [],
  message: "",
  connection: null,
  lastMessage: {},
  gifSearch: "",
  gifError: "",
  gifResult: "",
  selectedGif: null,
  SelectedImage: "",
  WhichTypeOfGif: "",
  currentUserId: null,
  windowWidth: window.innerWidth,
  pageCount: 1,
  totalPage: null,
  MessageType: messageType.text,
  IsFistMessage: false,
  CurrentScreenNumber: 0,
  ModalChildren: [],
  showModal: false,
  groupId: null,
};

export default connect(
  mapStateToProps,
  null
)(
  class Message extends React.PureComponent {
    constructor(props) {
      super(props);
      this.messageRef = createRef();
      this.messageEndRef = createRef();
      this.scrollRef = createRef();
      this.imageInputRef = createRef();

      this.state = initialState;
    }

    static getDerivedStateFromProps = (props, state) => {
      return {
        ...state,
        recieverId: props.recieverId,
        connection: state.connection,
      };
    };

    componentDidMount() {
      this.scrollToBottom();
      let tokenObject = parseJwt(getPlainToken());

      this.setState(
        {
          messageList: [],
          currentUserId: tokenObject.name,
        },
        () => {
          if (this.props.recieverId) {
            this.handleGroupId();
          }
        }
      );

      window.addEventListener("resize", this.setNewSize, false);
    }

    componentWillUnmount() {
      window.addEventListener("resize", this.setNewSize, false);
    }

    componentDidUpdate(prevProps, prevState) {
      if (this.state.pageCount === 1) {
        this.scrollToBottom();
      }

      if (
        prevProps.groupId !== this.props.groupId ||
        prevProps.recieverId !== this.props.recieverId
      ) {
        this.state.connection?.off("sendToUser");
        this.reset().then(() => {
          if (this.props.recieverId) {
            this.handleGroupId();
          }
        });
        this.createModalChildrens();
      }

      if (prevProps.allAthletesData !== this.props.allAthletesData) {
        this.createModalChildrens();
      }
    }

    handleGroupId = () => {
      this.props.groupId
        ? this.setState({ groupId: this.props.groupId }, async () => {
            this.buildHubConnection();
            await this.getMessages();
          })
        : this.getGroupId().then(async () => {
            this.buildHubConnection();
            await this.getMessages();
          });
    };

    setNewSize = () => {
      this.setState({ windowWidth: window.innerWidth });
    };

    listenToScroll = async (e) => {
      if (this.state.messageList.length) {
        const scrolled = e.target.scrollTop;

        if (scrolled < 30) {
          if (this.state.totalPage > this.state.pageCount) {
            this.setState(
              (prevState) => {
                return { pageCount: ++prevState.pageCount };
              },
              () => {
                e.target.scrollTop = 300;
                this.getMessages();
              }
            );
          }
        }
      }
    };

    buildHubConnection = async () => {
      if (this?.state?.groupId) {
        const newConnection = new SignalR.HubConnectionBuilder()
          .withUrl(
            `${projectSettings.baseUrl}/ChatUserHub?groupId=${this.state.groupId}`
          )
          .configureLogging(SignalR.LogLevel.Information)
          .build();

        await this.setState({
          connection: newConnection,
        });
        let _connection = this.state.connection;

        if (_connection) {
          _connection
            .start()
            .catch(function (err) {
              return console.error(err.toString());
            })
            .then(function () {
              _connection.invoke("GetGroupIdFromClient");
            });

          this.state.connection.on("sendToUser", (message) => {
            if (
              message.senderId !== this.state.currentUserId ||
              message.isWelcome
            ) {
              message.SenderId = this.state.groupId;
              let _message = {};
              _message.Date = new Date(message.date);
              _message.RecieverId = message.recieverId;
              _message.Message = message.message;
              _message.IsWelcome = message.isWelcome;
              _message.ImageUrl = message.imageUrl;
              _message.UserName = message.userName;
              _message.UserImage = message.userImage;
              _message.Type = message.type;

              let _intermediateChat = this.state.messageList;
              let response = {
                data: _message,
              };
              let index = _intermediateChat.length > 0 ? _intermediateChat : 0;
              if (index === 0) {
                _intermediateChat.push({
                  data: [response.data],
                  title: new Date().toDateString(),
                });
              } else {
                _intermediateChat[_intermediateChat.length - 1].data.push(
                  response.data
                );
              }
              this.setState({
                messageList: [..._intermediateChat],
              });

              this.scrollToBottom();
            }
          });
        }
      }
    };

    scrollToBottom = () => {
      let _messageRef = this.messageEndRef;
      _messageRef &&
        _messageRef.current &&
        _messageRef.current.scrollIntoView();
    };

    getGroupId = async () => {
      let url = `${projectSettings.baseUrl}/chats/GetUserGroup/${this.props.recieverId}`;
      let header = true;
      let type = "GET";
      let token = getPlainToken();
      let data = null;

      let response = "";

      if (response === "") {
        this.setState({ isLoading: true });
      }

      response = await callAPI(url, header, type, JSON.stringify(data), token);

      if (response) {
        this.setState({ isLoading: false });

        if (response.type === "error") {
        } else if (response.type === "success") {
          let { GroupId, UserName, Image, GroupType } = response.data;
          await this.setState({ groupId: GroupId });
          this.props.setGroupId(GroupId);
        }
      }
    };

    getMessages = async () => {
      let url = `${projectSettings.baseUrl}/chats/messages?pageNumber=${this.state.pageCount}`;
      let header = true;
      let type = "POST";
      let token = getPlainToken();
      let data = {};
      data = this.state.groupId;
      let response = "";

      if (response === "") {
        this.setState({ isLoading: true });
      }

      response = await callAPI(url, header, type, JSON.stringify(data), token);

      if (response) {
        this.setState({ isLoading: false });

        if (response.type === "error") {
        } else if (response.type === "success") {
          if (response.data?.Messages?.length === 0) {
            this.setState({
              IsFistMessage: true,
            });
          }

          this.setState({
            totalPage: response.data.TotalPages,
          });
          this.formatMessages(response.data.Messages);
        }
      }
    };

    handleMessageSubmit = async (e) => {
      e.preventDefault();
      if (this.state.message.length > 0 && this.state.groupId) {
        this.messageRef.current.value = "";

        let _message = this.createLocalMessage();
        this.appendNewMessage(_message);

        this.sendMessage(_message);

        this.scrollToBottom();
      }
    };

    sendGif = (data) => {
      this.setState(
        { selectedGif: data.images.original.url, MessageType: messageType.gif },
        () => {
          let _message = this.createLocalMessage();
          this.appendNewMessage(_message);

          this.sendMessage(_message);
        }
      );
      this.scrollToBottom();
      this.setState({ WhichTypeOfGif: null });
    };

    createLocalMessage = () => {
      let _message = {};
      let userData = this.props?.userData;

      _message.SenderId = userData?.Id;
      _message.Message = this.state.message;
      _message.Date = new Date().toUTCString();

      if (this.state.MessageType === messageType.gif) {
        _message.ImageUrl = this.state.selectedGif;
      } else if (this.state.MessageType === messageType.image) {
        _message.ImageUrl =
          projectSettings.baseImageUrl + "=" + this.state.SelectedImage;
      }

      _message.UserName = userData?.FirstName + " " + userData?.LastName;
      _message.UserImage = userData?.Image;
      _message.IsWelcome = false;
      _message.Uuid = uuid();
      _message.Unsent = false;
      _message.Type = this.state.MessageType;

      return _message;
    };

    sendMessage = async (newMessage) => {
      let url = `${projectSettings.baseUrl}/chats/save`;
      let header = true;
      let type = "POST";
      let token = getPlainToken();
      let data = {};
      let response = "";
      let _message = newMessage;
      data.RecieverId = this.state.groupId;
      data.Type = _message.Type;
      data.Date = _message.Date;

      if (data.Type === messageType.text) {
        data.Message = this.state.message;
      } else if (data.Type === messageType.gif) {
        data.ImageUrl = _message.ImageUrl;
      } else if (data.Type === messageType.image) {
        data.ImageUrl = _message.ImageUrl;
      }

      if (this.state.IsFistMessage) {
        this.props.setUsersFirstMessage(_message);
        this.setState({
          IsFistMessage: false,
        });
      }

      this.setState({
        message: "",
        selectedGif: null,
        MessageType: messageType.text,
      });

      response = await callAPI(url, header, type, JSON.stringify(data), token);

      if (response) {
        if (response.type === "error") {
          this.showMessageWasNotSent(_message.Uuid);
        } else if (response.type === "success") {
          this.setState({ selectedGif: null, WhichTypeOfGif: null });
        }
      }
    };

    findDesiredMessage = (_messageList, _uuid) => {
      let desiredMessage = null;

      if (_uuid) {
        desiredMessage = _messageList[_messageList.length - 1].data.find(
          (_message) => _message.Uuid === _uuid
        );
      }

      return desiredMessage;
    };

    showMessageWasNotSent = async (_uuid) => {
      let _messageList = this.state.messageList;
      let messageWhichWasNotSent = this.findDesiredMessage(_messageList, _uuid);
      messageWhichWasNotSent.Unsent = true;

      await this.setState({
        messageList: [..._messageList],
      });
    };

    appendNewMessage = (messageData) => {
      let _intermediateChat;

      if (!this.state.messageList.length) {
        _intermediateChat = [
          {
            title: this.extractDate(new Date()),
            data: [],
          },
        ];
      } else {
        _intermediateChat = this.state.messageList;
      }

      if (
        this.extractDate(messageData.Date) !==
        this.extractDate(_intermediateChat[_intermediateChat.length - 1].title)
      ) {
        _intermediateChat.push({
          title: this.extractDate(messageData.Date),
          data: [messageData],
        });
      } else {
        _intermediateChat[_intermediateChat.length - 1].data.push(messageData);
      }

      this.setState({
        messageList: [..._intermediateChat],
      });
    };

    uniqueDate = (data) => {
      const unique = [
        ...new Set(data.map((item) => this.extractDate(item.Date))),
      ];
      return unique;
    };

    extractDate = (date) => {
      if (date) {
        let targetDate = new Date(date);
        return targetDate.toDateString();
      }
    };

    formatMessages = (chatInfo) => {
      let uniqueDates = this.uniqueDate(chatInfo);
      let op = [];
      let _message;

      for (let date of uniqueDates) {
        _message = chatInfo.filter((currVal) => {
          return this.extractDate(currVal.Date) === this.extractDate(date);
        });

        op.push({
          title: date,
          data: _message,
        });
      }

      this.setState({ messageList: [...op, ...this.state.messageList] });
    };

    selectImage = (e) => {
      let _file = e.target.files[0];
      let _fileType = messageType.image;

      let _message = this.createLocalMessage();
      this.uploadImage(_file, _fileType, _message);

      _message.ImageUrl = alternateImage;
      this.appendNewMessage(_message);
    };

    uploadImage = async (file, fileType, message) => {
      let url = `${projectSettings.baseUrl}/chats/uploadfile`;
      let header = false;
      let type = "POST";
      let token = getPlainToken();
      let data = new FormData();

      data.append("File", file);
      data.append("FileType", fileType);

      let response = "";

      response = await callAPI(url, header, type, data, token);

      if (response) {
        if (response.type === "error") {
          this.showMessageWasNotSent(message.Uuid);
        } else if (response.type === "success") {
          let _messageList = this.state.messageList;
          let desiredMessage = this.findDesiredMessage(
            _messageList,
            message.Uuid
          );

          desiredMessage.ImageUrl = response.data.ImageName;
          desiredMessage.Type = fileType;

          this.setState(
            {
              SelectedImage: response.data.ImageName,
              messageList: [..._messageList],
            },
            () => {
              this.sendMessage(message);
            }
          );

          this.imageInputRef.current.value = null;
        }
      }
    };

    createModalChildrens = () => {
      const modalChilren = [
        {
          screenNumber: 0,
          component: GroupDetails,
          props: {
            groupId: this.props.groupId,
            groupDetailsModalId: groupDetailsModalId,
            resetModalInfo: this.resetStateWhenModalIsClosed,
            setRemoveUserWithThisId: this.props.setRemoveUserWithThisId,
            resetMessageScreen: this.props.resetMessageScreen,
          },
        },
        {
          screenNumber: 1,
          component: CreateCustomGroup,
          props: {
            allAthletesData: this.props.allAthletesData,
            groupContainerStyle: "p-2",
            modalId: groupDetailsModalId,
            resetModalInfo: this.resetStateWhenModalIsClosed,
            handleUserSelection: this.props.changeMessageList,
            getNewChats: this.props.getNewChats,
          },
        },
      ];

      this.setState({
        ModalChildren: modalChilren,
      });
    };

    updatePropsOfAScreen = (screenNumber, aditionalProps) => {
      const desiredComponent = this.state.ModalChildren.find(
        (eachItem) => eachItem.screenNumber === screenNumber
      );

      desiredComponent.props = { ...desiredComponent.props, aditionalProps };
      let _modalChildren = this.state.ModalChildren;

      _modalChildren[screenNumber] = desiredComponent;

      this.setState({
        ModalChildren: _modalChildren,
        CurrentScreenNumber: screenNumber,
      });
    };

    closeGroupDetailsModal = () => {
      closeModel(groupDetailsModalId);
    };

    goToPrevScreen = () => {
      let { CurrentScreenNumber } = this.state;

      if (CurrentScreenNumber) {
        this.setState({
          CurrentScreenNumber: --CurrentScreenNumber,
        });
      }
    };

    goToNextScreen = (props) => {
      let { CurrentScreenNumber, ModalChildren } = this.state;

      if (CurrentScreenNumber < ModalChildren.length) {
        if (props) {
          let _nextScreeenNumber = ++CurrentScreenNumber;
          this.updatePropsOfAScreen(_nextScreeenNumber, props);
        } else {
          this.setState({
            CurrentScreenNumber: ++CurrentScreenNumber,
          });
        }
      }
    };

    showModal = () => {
      if (
        this.props.groupType &&
        this.props.groupType !== chatGroupEnum.OneToOne
      ) {
        this.setState(
          {
            showModal: true,
          },
          () => {
            openModel(groupDetailsModalId);
          }
        );
      }
    };

    hideModal = () => {
      this.setState({
        showModal: false,
      });
    };

    resetStateWhenModalIsClosed = () => {
      this.setState(
        {
          CurrentScreenNumber: 0,
        },
        () => {
          this.closeGroupDetailsModal();
          this.hideModal();
          this.createModalChildrens();
        }
      );
    };

    reset = async () => {
      if (this.imageInputRef?.current) {
        this.imageInputRef.current.value = null;
      }
      if (this.messageRef?.current) {
        this.messageRef.current.value = null;
      }

      await this.setState({
        messageList: [],
        message: "",
        connection: null,
        lastMessage: {},
        gifSearch: "",
        gifError: "",
        gifResult: "",
        selectedGif: null,
        SelectedImage: "",
        WhichTypeOfGif: "",
        windowWidth: window.innerWidth,
        pageCount: 1,
        totalPage: null,
        MessageType: messageType.text,
      });
    };

    render() {
      let messageToBeSend = this.state.message;

      return (
        <div className="content">
          <div
            className={`contact-profile shadow-sm nameBanner ${
              this.state.groupId &&
              this.props.groupType &&
              this.props.groupType !== chatGroupEnum.OneToOne &&
              "pointerCursor"
            }`}
            onClick={this.showModal}
          >
            {this.props && this.props.UserName && (
              <div
                style={{
                  display: "flex",
                  height: "inherit",
                  marginLeft: "40px",
                  alignItems: "center",
                  columnGap: "15px",
                  marginTop: "2px",
                }}
              >
                <DisplayPicture
                  className="profileImageBig"
                  image={this.props.receiverImage}
                  showGroupAvatar={
                    this.props.groupType !== chatGroupEnum.OneToOne
                  }
                />
                <p className="mt-3">{this.props.UserName}</p>
              </div>
            )}
          </div>
          <div
            className="messages primaryScrollBar"
            onScroll={(e) => {
              e.preventDefault();
              this.listenToScroll(e);
            }}
            ref={this.scrollRef}
          >
            {this.state.isLoading && <Spinner />}
            <ul className="list-style-none">
              {this.state.messageList.length > 0 &&
                this.state.messageList.map((sectionList) => {
                  return (
                    <MessageSectionList
                      userId={this.props.userData.Id}
                      sectionList={sectionList}
                      scrollToBottom={this.scrollToBottom}
                    />
                  );
                })}
            </ul>

            <input
              ref={this.messageEndRef}
              id="messageBox"
              style={{ height: "1px", opacity: 0 }}
            />

            <div
              className={`${this.state.WhichTypeOfGif && "inputCotnainerOpen"}`}
            >
              {this.props && this.props.UserName && (
                <div
                  className={`message-input ${
                    this.state.WhichTypeOfGif
                      ? "message-inputWithGif"
                      : "message-inputWithoutGif"
                  }`}
                >
                  <div className="wrap ml-2 mb-0">
                    <form
                      className="d-flex"
                      onSubmit={(e) => this.handleMessageSubmit(e)}
                    >
                      <div
                        className={`d-flex align-items-center messageContainer pointerCursor`}
                      >
                        <span
                          className="messageIcon gifIconStyle"
                          onClick={() => {
                            this.setState({ WhichTypeOfGif: gifTypes.gif });
                          }}
                        >
                          GIF
                        </span>

                        <span
                          className="ml-2 pointerCursor"
                          onClick={() => {
                            this.setState({ WhichTypeOfGif: gifTypes.sticker });
                          }}
                        >
                          <i className="mdi mdi-sticker messageIcon pointerCursor"></i>
                        </span>

                        <span className="ml-2 position-relative">
                          <input
                            ref={this.imageInputRef}
                            type="file"
                            className="hiddenSenderImageField pointerCursor"
                            id="image"
                            accept="image/*"
                            onChange={this.selectImage}
                          />
                          <i className="mdi mdi-image senderSendImageIcon"></i>
                        </span>

                        <input
                          type="text"
                          ref={this.messageRef}
                          onChange={(e) => {
                            this.setState({ message: e.target.value });
                          }}
                          onFocus={() => {
                            this.setState({ WhichTypeOfGif: null });
                          }}
                          placeholder="Write your message..."
                        />
                      </div>

                      <button className="p-2 backgroundNone" type="submit">
                        <i
                          className={`mdi mdi-send messageIcon primaryColor ${
                            !messageToBeSend && "opacityLow"
                          }`}
                          aria-hidden="true"
                        ></i>
                      </button>
                    </form>
                  </div>
                </div>
              )}
              <GifsandStickers
                whichType={this.state.WhichTypeOfGif}
                handleSelection={this.sendGif}
              />
            </div>
          </div>

          {/* Group Details Modal */}
          {this.state.groupId && this.state.showModal && (
            <div
              className="modal fade"
              id={groupDetailsModalId}
              tabindex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content border-0">
                  <div class="modal-header align-items-center">
                    {this.state.CurrentScreenNumber > 0 && (
                      <div
                        className="noBgBtn mr-2"
                        onClick={this.goToPrevScreen}
                      >
                        <span className="mdi mdi-arrow-left pointerCursor"></span>
                      </div>
                    )}
                    <h5 class="modal-title">{this.props.UserName}</h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={this.resetStateWhenModalIsClosed}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body p-0">
                    <ModalBody
                      CurrentScreenNumber={this.state.CurrentScreenNumber}
                      ModalChildren={this.state.ModalChildren}
                      goToPrevScreen={this.goToPrevScreen}
                      goToNextScreen={this.goToNextScreen}
                      updatePropsOfAScreen={this.updatePropsOfAScreen}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* Group Details Modal end */}
        </div>
      );
    }
  }
);
